<template>
  <div class="p_demand_info page_recruitInfoRead">
    <div class="r_info_dtl">
      <p v-if="proDtl.StrservuserNname">
        <span>客服：</span>
        <span>{{proDtl.ServiceDepName?proDtl.ServiceDepName+'/':''}}{{proDtl.StrservuserNname?proDtl.StrservuserNname+'/':''}}{{proDtl.StrservuserMobile?proDtl.StrservuserMobile:''}}</span>
      </p>
      <p v-if="proDtl.StrProManagerName">
        <span>项目管理员：</span>
        <span>{{proDtl.StrProManagerName?proDtl.StrProManagerName+'/':''}}{{proDtl.StrProManagerName?proDtl.StrProManagerName:''}}</span>
      </p>
    </div>
    <div class="info_Item">
      <div class="flex f_form" style="margin-bottom: 8px">
        <div class="info_Item_Title">基本信息</div>
        <div class="p_plan_item">
        </div>
        <!-- <div style="padding-right: 100px;">
          <div v-show="projectpersondetails.StrservuserNname">客服：{{ projectpersondetails.ServiceDepName + '/'+ projectpersondetails.StrservuserNname + '/' + projectpersondetails.StrservuserMobile }}</div>
          <div v-show="projectpersondetails.StrAchieveownerName">业务员：{{ projectpersondetails.StrbusdepName + '/'+ projectpersondetails.StrAchieveownerName + '/' + projectpersondetails.StrAchieveownerMobile }}</div>
          <div v-show="projectpersondetails.StrProManagerName">运营：{{ projectpersondetails.StrProManagerDep + '/'+ projectpersondetails.StrProManagerName + '/' + projectpersondetails.StrProManagerMobile }}</div>
        </div> -->
      </div>
      <div class="demandForm">
        <el-form :model="query" :inline="true" label-width="132px">
          <el-form-item label="项目名称：">{{query.StrprojectName}}</el-form-item>
          <el-form-item label="劳动关系：">{{query.LaborRelation}}</el-form-item>
          <el-form-item label="岗位属性：">{{query.JobType}}</el-form-item>
          <el-form-item label="岗位类型：">{{query.JobCategory}}</el-form-item>
          <el-form-item label="岗位名称：">{{query.CustomerJobName}}</el-form-item>
          <el-form-item label="班次：">{{query.WorkingShift}}</el-form-item>
          <el-form-item label="需求人数：">{{query.NeedAmount}}</el-form-item>
          <el-form-item label="需求附件：">
            <span v-if="isImg" @click="showImgHandle" style="cursor:pointer;color:#19bd92;">{{query.DemandAttachmentFileName}}</span>
            <a style="color:#19bd92;" v-else :href="headUrl + query.DemandAttachment">{{!isNull(query.DemandAttachmentFileName)?'附件':''}}</a>
          </el-form-item>
          <el-form-item label="站/坐班：">{{query.Workingposition}}</el-form-item>
          <div class="address" style="display: inline-block">
            <el-form-item label="工作城市：">{{query.WorkAreaName ? (query.WorkProvinceName + '/'+ query.WorkCityName + '/' + query.WorkAreaName) : query.WorkCityName ? query.WorkProvinceName + '/'+ query.WorkCityName : query.WorkProvinceName}}</el-form-item>
          </div>
          <div class="txtbox">
            <el-form-item label="工作内容：">{{query.JobContent}}</el-form-item>
          </div>
          <!-- 岗位要求 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 8px">任职要求</div>
          <el-form-item label="性别要求：">{{query.Gender}}</el-form-item>
          <el-form-item label="年龄要求：">{{query.AgeReqStart}} ~ {{query.AgeReqEnd}}</el-form-item>
          <el-form-item label="证书要求：">{{CertificateRequirements}}</el-form-item>
          <el-form-item label="工作经验要求：">{{query.ExperienceReq}}</el-form-item>
          <el-form-item label="民族要求：">{{query.NationalityRequire}}</el-form-item>
          <el-form-item label="学历要求：">{{query.Degree}} （{{query.Degree1}}）</el-form-item>
          <el-form-item label="接受残疾人：">{{query.AcceptDisabled == 'true' ? '是' : '否'}}</el-form-item>
          <el-form-item label="接受残疾人备注：">{{query.AcceptDisabledRemark}}</el-form-item>
          <div class="address">
            <el-form-item label="限制地区：">{{query.LimitProvinceName}}</el-form-item>
          </div>


          <!-- 工作时间 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 8px">工作时间</div>

          <el-form-item label="需要加班：">{{query.IsOverTime == 'true' ? '是' : '否'}}</el-form-item>
          <el-form-item label="排班周期：">{{query.CycleTimetable}}</el-form-item>
          <el-form-item label="月休：">{{query.MonthlyRest}}</el-form-item>

          <div>
            <el-form-item label="上班时间：">{{query.AttendanceTime}}</el-form-item>
          </div>

          <!-- 薪资福利（明细） -->
          <div class="info_Item_Title f_form" style="margin-bottom: 8px">薪资福利（明细）</div>

          <el-form-item label="薪资类型：">{{query.PayType}}</el-form-item>
          <el-form-item label="发薪方式：">{{query.MethodOfPay}}</el-form-item>
          <el-form-item label="正式薪资标准：">{{query.SalaryAfterFullEmployment + query.SalaryAfterFullEmploymentUnit}}</el-form-item>
          <el-form-item label="试用期薪资标准：">{{query.SalaryduringProbationPeriod + query.SalaryduringProbationPeriodUnit}}</el-form-item>
          <el-form-item label="综合薪资：">{{query.ComprehensiveSalary}}~{{ query.ComprehensiveSalaryEnd }}</el-form-item>

          <el-form-item label="发薪日：">{{query.PayDate ? query.PayDate + '号' : ''}}</el-form-item>
          <el-form-item label="无薪资周期：">{{query.UnpaidPeriod}}天</el-form-item>
          
          <div class="txtbox">
            <el-form-item label="无薪资备注：">{{query.UnpaidPeriodRemark}}</el-form-item>
          </div>

          <div>
            <el-form-item label="是否包住：">{{query.IncludeStay}}</el-form-item>
            <el-form-item label="是否包吃：">{{query.PackageEat}}</el-form-item>
          </div>

          <div class="txtbox">
            <el-form-item label="食宿备注：">{{query.IncludeStayEatRemark}}</el-form-item>
          </div>

          <el-form-item label="是否交通车：">{{query.ThroughTrainNot}}</el-form-item>

          <el-form-item label="夜班补贴：">{{query.NightShiftSubsidy}}</el-form-item>
          <el-form-item label="加班补贴：">{{query.OvertimeSubsidy}}</el-form-item>
          <el-form-item label="社保缴纳方式：">{{query.SocialSecurityPaymentMethod}}</el-form-item>

          <div class="txtbox">
            <el-form-item label="社保备注：">{{query.SsPaymentMethodRemark}}</el-form-item>
          </div>

          <el-form-item label="公积金缴纳方式：">{{query.AccumulationFundPaymentMethod}}</el-form-item>

          <div class="txtbox">
            <el-form-item label="公积金备注：">{{query.PfPaymentMethodRemark}}</el-form-item>
          </div>

          <div class="txtbox">
            <el-form-item label="备注：">{{query.CompensationAndWelfareRemark}}</el-form-item>
          </div>
          
          <el-form-item label="工作&宿舍环境：" style="display: block">
            <div class="workImg" v-if="query.WorkAndDormitoryEnvironment.length>0">
              <el-image v-for="item in query.WorkAndDormitoryEnvironment" :key="item.Id" :src="headUrl + item.Url" alt="" :preview-src-list="srcList"></el-image>
            </div>
          </el-form-item>


          <!-- 培训晋升 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 8px">培训/试工</div>

          <el-form-item label="培训周期：">{{query.TrainCycle}}{{query.PayforTraining ? '（培训有薪资）' : ''}}</el-form-item>
          <el-form-item label="试工周期：">{{query.Trialperiod}}{{query.TrialWorkisPaid ? '（试工有薪资）' : ''}}</el-form-item>

          <!-- 面试信息 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 8px">面试信息</div>

          <div class="address">
            <el-form-item label="面试地址详情：">
              {{query.InterviewAddress ? interAddress + '/' + query.InterviewAddress : interAddress }}
              <span>
                <el-popover placement="bottom" width="800" trigger="click">
                  <div class="mapContainer">
                    <div id="mapSelector" style="width: 800px;height: 400px;"></div>
                  </div>
                  <!-- <el-button slot="reference" type="text"> <i class="el-icon-location"></i></el-button> -->
                </el-popover>
              </span>
            </el-form-item>
          </div>
          <!-- <el-form-item label="面试交通路线：">{{query.InterviewTransportation}}</el-form-item>
          <el-form-item label="工作地点交通路线：">{{query.WorkTransportation}}</el-form-item> -->
          <div class="txtbox">
            <el-form-item label="面试流程：">{{query.InterviewProcess}}</el-form-item>
          </div>

          <div class="txtbox">
            <el-form-item label="面试注意事项：">{{query.InterviewTips}}</el-form-item>
          </div>
          <!-- 入职信息 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 8px">入职信息</div>

          <el-form-item label="是否需要押金：">{{query.IsNeedDeposit}}</el-form-item>
          <el-form-item label="押金类型：">{{query.DepositType}}</el-form-item>
          <el-form-item label="押金说明：">{{query.DepositExplain}}</el-form-item>
          <div>
            <el-form-item label="是否需要体检：">{{query.MedicalExaminationReq}}</el-form-item>
            <el-form-item label="体检类型：">{{query.TypeofPhysicalExamination}}</el-form-item>
            <el-form-item label="体检金额：">{{query.AmountofPhysicalExamination}}元</el-form-item>
            <el-form-item label="体检医院：">{{query.MedicalExaminationHospita}}</el-form-item>
            <el-form-item label="体检费：">{{query.PhysicalExaminationFee}}</el-form-item>
            <el-form-item label="报销说明：">{{query.MedicalExaminationrReimbursementStatement}}</el-form-item>
          </div>

         <div class="address">
          <el-form-item label="上班地址：">
            {{workAddress +'  ' + query.EntryAddress}} 
            <a v-if="query.EntryAttachmentFile" :href="headUrl + query.EntryAttachmentFile">{{query.EntryAttachmentFileName ? query.EntryAttachmentFileName : '附件'}}</a></el-form-item>
         </div>
         <div class="txtbox">
          <el-form-item label="入职流程/注意事项：">{{query.ProcessTip}}</el-form-item>
          </div>
          <div class="txtbox">
            <el-form-item label="体检流程/注意事项：">{{query.ProcedurePhysicalExamination}}</el-form-item>
          </div>
          
        </el-form>

      </div>
    </div>
    <!-- 需求附件弹框 -->
    <el-dialog title="" :visible.sync="imgVisible" width="820px">
      <div class="img_dialog" v-loading="imgLoading">
        <img :src="headUrl + query.DemandAttachment" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";
import moment from 'moment';
export default {
  name: "recruitInfoRead",
  data() {
    return {
      imgLoading:false,
      imgVisible:false,
      isImg:false,
      LimitProvinceName: '',//限制地区
      AttendanceTime: '',//上班时间
      CertificateRequirements:'',
      srcList:[],
      // 项目详情
      proDtl: {
        StrProManagerName: '', // 项目管理员
        StrProManagerMobile: '',
        StrservuserNname: '', // 客服
        StrservuserMobile: '',
        ServiceDepName: '' // 服务中心
      },
      query: {
        Id: '',
        ProjectId: '',
        LaborRelation: '',
        JobType: '',
        JobCategory: '',
        customerJobName: '',
        NeedAmount: '',
        DemandAttachment: '',
        DemandAttachmentFileName: '',
        WorkCity: [],
        workProvince: '',
        WorkArea: '',
        WorkAddress: '',
        JobContent: '',
        Degree: '',
        Gender: '',
        AgeReqStart: '',
        AgeReqEnd: '',
        ExperienceReq: '',
        OtherReq: '',
        SalaryAfterFullEmployment: '',
        SalaryAfterFullEmploymentUnit: 84,
        IsAdvanceAccount: 0,
        SalaryduringProbationPeriod: '',
        SalaryduringProbationPeriodUnit: 84,
        trainingPeriodSalary: '',
        PackageEat: '',
        SocialSecurityPaymentMethod: '',
        PayDate: '',
        Timetable: '',
        CycleTimetable: '',
        IsFixedCaclss: '',
        IsOverTime: '',
        TrainCycle: '',
        TrainingIsObsolete: '',
        HavePromotion: '',
        DescriptionAdvantages: '',
        DescriptionDisadvantages: '',
        InterviewProvince: '',
        InterviewCity: '',
        InterviewArae: '',
        InterviewAddress: '',
        InterviewTransportation: '',
        WorkTransportation: '',
        InterviewProcess: '',
        InterviewTips: '',
        PeriodEntry: '',
        IsNeedDeposit: '',
        ProcessTip: '',
        JobDescriptionAttachment: '',
        JobDescriptionAttachmentFileName: '',
        NumberGaps: '',
        DescriptioGapFile: '',
        RecruitmentStartTime: '',
        RecruitmentEenTime: '',
        InterviewAddressUrl: '',
        Lng: '',
        Lat: '',
        WorkAndDormitoryEnvironment: [],
        InterviewProvinceName: '',
        InterviewCityName: '',
        InterviewAraeName: '',
        Workingposition: '无',
        WorkingShift: '',
        NationalityRequire: [],
        CertificateRequirements: '',
        DescriptionofSalary: '',
        ComprehensiveSalary: '',
        BasicSalary: '',
        TemporarySupportStandard: '',
        MedicalExaminationReq: '',
        MedicalExaminationHospita: '',
        MedicalExaminationFee: '',
        MedicalExaminationFeeCondition: '',
        ProcedurePhysicalExamination: '',
        IncludeStay: '',
        RealWorkCity: '',
        RealWorkProvince: '',
        RealWorkArea: '',
        RealWorkCityName: '',
        RealWorkAddress: '',
        RealWorkAreaName: '',
        RealWorkProvinceName: ''
      },
      interAddress: '',
      workAddress: '',
      dialogVisiblePic: false,
      dialogImageUrl: '',
      map: null, //地图控件
      marker: null, //地图点
      coordinate: null, //坐标点
      backupCoord: null, //用于备份
      lat: '',
      lng: '',
      addressName: '',
      projectpersondetails: {},
      headUrl: location.origin.indexOf('localhost') > -1 ? 'https://dev.joball.net/clouddoc/' : location.origin + '/clouddoc/'
    }
  },
  created() {
    let q = this.$route.query;
    if (q.proId && q.proId != undefined) {
      this.query.ProjectId = this.$route.query.proId;
      this.query.Id = this.$route.query.id;
      this.isEdit = this.$route.query.isEdit;
      if (this.isEdit) {
        this.getjobdetails();
        this.getprojectpersondetails()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    })
  },
  methods: {
    showImgHandle(){
      let url = this.headUrl + this.query.DemandAttachment
      if(this.isNull(url)){
        this.imgLoading = true
      }else{
        this.imgLoading = false
      }
      this.imgVisible = true
    },
    //图片预览
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisiblePic = true;
    },
    //失去焦点获取数据
    blurSearch() {
      //有值才搞
      if (this.query.InterviewArae) {
        this.fixMarker(this.query.InterviewArae);
      }
    },
    //固定点
    fixMarker(code) {
      const store = this.$store.getters;
      let address = store.codeToggleObj(code);
      let addressName = store.localName(address, ","); //名称
      if (this.query.InterviewAddress) addressName += "," + this.query.InterviewAddress;
      const _this = this;
      let geocoder = new qq.maps.Geocoder();
      geocoder.getLocation(addressName);
      geocoder.setComplete((result) => {
        let detail = result.detail;
        let coordinate = detail.location; //坐标
        _this.query.lat = coordinate.lat;
        _this.query.lng = coordinate.lng;
        _this.backupCoord = _this.coordinate = coordinate; //保存坐标点
        _this.map.setCenter(coordinate); //移动地图中心
        _this.marker.setPosition(coordinate);
      })
    },
    //根据当前的地址换算坐标点
    toggleCoordinate(code) {
      const _this = this;
      const store = this.$store.getters;
      let address = store.codeToggleObj(code);
      let addressName = store.localName(address, ","); //名称
      if (this.query.InterviewAddress) addressName += "," + this.query.InterviewAddress;
      let geocoder = new qq.maps.Geocoder();
      geocoder.getLocation(addressName);
      geocoder.setComplete(function (result) {
        let detail = result.detail;
        let coordinate = detail.location; //坐标
        _this.query.lat = coordinate.lat;
        _this.query.lng = coordinate.lng;
        _this.query.InterviewAddress = store.localName(address);
      })
    },
    //创建腾讯地图
    initMap() {
      const _this = this;
      const mapContainer = document.getElementById("mapSelector");
      let initLatLng = new qq.maps.LatLng(_this.lat, _this.lng);
      let myOptions = {
        zoom: 15,
        center: initLatLng,
        panControl: false, //平移控件
        zoomControl: false, //缩放控件
        mapTypeControl: false, //地图类型
      }
      this.map = new qq.maps.Map(mapContainer, myOptions);
      this.marker = new qq.maps.Marker({
        position: initLatLng,
        map: this.map
      });
      qq.maps.event.addListener(_this.map, 'click', function (e) {
        let coord = e.latLng;
        _this.coordinate = coord;
        _this.marker.setPosition(coord);
      });
      let resetBounds = function () {
        var bounds = _this.map.getBounds();     //获取函数范围
      }
      //拖拽结束后触发
      qq.maps.event.addListener(_this.map, 'dragend', resetBounds);
      //地图缩放时触发
      qq.maps.event.addListener(_this.map, 'zoom_changed', resetBounds);
      //自定义控件
      let focus = document.createElement("div");
      focus.className = "focusBtn";
      //将控件添加到controls栈变量并将其设置在顶部位置
      this.map.controls[qq.maps.ControlPosition.LEFT_BOTTOM].push(focus);
      focus.addEventListener('click', function () {
        _this.coordinate = _this.backupCoord; //保存坐标点
        if (_this.marker) {
          _this.map.setCenter(_this.backupCoord); //移动地图中心
          _this.marker.setPosition(_this.backupCoord);
        }
      })
    },
    // 获取项目详情
    getprojectpersondetails() {
      xz.getprojectpersondetails(this.query.ProjectId, localStorage.loginRoletype).then(res => {
        // console.log('ee',res)
        let r = res.data;
        if (res.status == 'ok') {
          this.proDtl = {
            StrProManagerName: r.StrProManagerName, // 项目管理员
            StrProManagerMobile: r.StrProManagerMobile,
            StrservuserNname: r.StrservuserNname, // 客服
            ServiceDepName: r.ServiceDepName,
            StrservuserMobile: r.StrservuserMobile // 客服手机号
          }
        } else {
          this.$message.error('获取项目详情出错')
        }
      })
    },
    getjobdetails() {
      xz.getjobdetails(this.query.Id).then(res => {
        let r = JSON.parse(res);
        if (r.status == 'ok') {
          this.query = r.data;
          this.projectperson(r.data.ProjectId);
          this.interAddress = r.data.InterviewProvinceName == '线上面试' ? r.data.InterviewProvinceName : r.data.InterviewProvinceName + '/' + r.data.InterviewCityName + '/' + r.data.InterviewAraeName;
          this.workAddress = r.data.EntryProvince + '-' + r.data.EntryCity + '-' + r.data.EntryAraeEntry;
          // this.query.AttendanceTime = JSON.parse(r.data.AttendanceTime);
          // this.LimitProvinceName = '';
          // this.query.LimitProvinceName = JSON.parse(this.query.LimitProvinceName)
          if(!this.isNull(this.query.DemandAttachment)){
            if(this.query.DemandAttachment.indexOf('.png')>-1||this.query.DemandAttachment.indexOf('.jpg')>-1||this.query.DemandAttachment.indexOf('.gif')>-1){
              this.isImg = true
            }else{
              this.isImg = false
            }
          }
          // if (!this.isNull(this.query.LimitProvinceName)) {
          //   this.query.LimitProvinceName.forEach((element, index) => {
          //     this.LimitProvinceName = this.LimitProvinceName ? this.LimitProvinceName + ',' + element.name : element.name
          //   });
          // }
          if (!this.isNull(this.query.CertificateRequirements)) {
            let arr = this.query.CertificateRequirements.split(',')
            arr.forEach((element, index) => {
              let item = element.split('-')[1];
              this.CertificateRequirements = this.CertificateRequirements ? this.CertificateRequirements + ',' + item : item
            });
          }
          // var AttendanceTime = '';
          // this.query.AttendanceTime.forEach((element, index) => {
          //   AttendanceTime = index == 0 ? AttendanceTime + element.startTime + '~' + element.endTime : AttendanceTime + ',' + element.startTime + '~' + element.endTime
          //   if (index + 1 == this.query.AttendanceTime.length) {
          //     this.AttendanceTime = AttendanceTime
          //   }
          // });
          if(!this.isNull(this.query.WorkAndDormitoryEnvironment)){
            this.query.WorkAndDormitoryEnvironment.forEach(element => {
              this.srcList.push(this.headUrl + element.Url)
            });
            
          }
          this.fixMarker(this.query.InterviewArae)
          console.log('o', this.query,)
        } else {
          this.$message.error('获取需求详情出错')
        }
      })
    },
    projectperson(id) {
      xz.getprojectpersondetails(id).then(res => {
        if (res.status == 'ok') {
          this.projectpersondetails = res.data;
        }
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    }
  }
}
</script>
<style scoped>
.img_dialog{
  display: flex;
  justify-content: center;
  align-items: center;
}
.img_dialog img{
  max-width: 100%;
  max-height: 700px;
}
/* .address {
  width: 100%;
} */
.r_info_dtl {
  font-size: 14px;
  /* color: #19bd92; */
  color: #333;
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
}
.f_form {
  border-bottom: 1px solid #ddd;
}
.info_Item_Title {
  line-height: 30px;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  margin-right: 100px;
}
.p_plan_item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
}
.p_plan_title {
  margin-right: 12px;
}
.p_plan_right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.p_plan_upload {
  display: flex;
  align-items: baseline;
}
.crossbar {
  margin: 0 10px;
}

.btnBox {
  padding: 20px 0;
  width: 98%;
  display: flex;
  justify-content: center;
}
.workImg {
  display: flex;
}
.workImg img {
  width: 146px;
  height: 146px;
  margin: 5px 10px;
}
</style>

<style>
.page_recruitInfoRead .el-form-item__label{
  color:#999;
}
.page_recruitInfoRead .el-form-item__content,
.page_recruitInfoRead .el-form-item__label {
  line-height: 25px;
}
.page_recruitInfoRead .el-form-item {
  margin-bottom: 0px;
}
.page_recruitInfoRead .el-form--inline .el-form-item {
  width: 270px;
  margin-right: 0;
}
.page_recruitInfoRead .el-divider--horizontal {
  margin: 0;
}
.page_recruitInfoRead .el-form-item__label {
  padding: 0;
}
.page_recruitInfoRead .el-form-item__content {
  width: 137px;
}
.page_recruitInfoRead .address .el-form-item {
  width: 500px;
}
.page_recruitInfoRead .address .el-form-item__content {
  width: 300px;
}
.page_recruitInfoRead .txtbox .el-form-item {
  width:100%
}
.page_recruitInfoRead .txtbox .el-form-item__content {
  width:calc(100% - 200px)
}
</style>
